import React, { FC } from 'react';
import styled from 'styled-components';

import FontIcon from '../FontIcon';
import { Slider } from '../Toggle/Slider';
import { ItemProps } from './types';
import Typography from '../Typography';

const Row = styled.div<any>`
  padding: 7px 0px;
`;

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ToggleContainer = styled.div`
  margin-top: 0px;
`;

interface SliderItemProps {
  checked?: boolean;
  item: ItemProps;
  onChange: (value: string, checked: boolean) => void;
  hideBottomBorder: boolean;
}

export const SliderItem: FC<SliderItemProps> = ({
  onChange,
  item,
  checked,
  hideBottomBorder,
}) => {
  const onClick = () => onChange(item.value, !checked);

  return (
    <Row hideBottomBorder={hideBottomBorder} onClick={onClick}>
      <TitleRow>
        <Typography
          variant={item.isNew ? 'titleMediumEmphasized' : 'bodyLarge'}
          color="var(--sys-color--on-surface-variant)"
          style={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: '8px' }}
        >
          {item.title}
          {item.showWarning && (
            <FontIcon
              name="warning"
              color="var(--sys-color-extended--goldenrod)"
              size={20}
              fill={true}
            />
          )}
        </Typography>
        <ToggleContainer>
          <Slider id={item.id + "-" + checked} checked={checked} />
        </ToggleContainer>
      </TitleRow>
    </Row>
  );
}